// extracted by mini-css-extract-plugin
export default {"main":"Contract_main__OQf11"};